import React from 'react';
import { isEmptyString } from '../../lib/Utils';

import { TextMask, InputAdapter } from 'react-text-mask-hoc';
const { editors: { EditorBase } } = require('react-data-grid');
export default class ZipCodeEditor extends EditorBase {

  render() {
/*
    return (<input ref={(node) => this.input = node} type="text" onBlur={this.props.onBlur} className="form-control" defaultValue={this.props.value} />);
*/
    return (
      <TextMask
        // You can provide your own adapter component or use one of included in the library.
        Component={InputAdapter}
        mask={[ /\d/, /\d/, /\d/, /\d/, /\d/]}
        guide={true}
      />);

  }
}



// WEBPACK FOOTER //
// ./src/components/ZipCodeEditor/ZipCodeEditor.js